import { Button, Tooltip } from "@mantine/core";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import { IconDeviceFloppy } from "@tabler/icons-react";
import { useUIStore } from "../../../../../../stores/UIStore";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";

const WorkflowSaver = () => {
  const lang = useLanguage((s) => s.language);
  const navbarClosed = useUIStore((s) => s.navbarClosed);
  const setToSave = useFlowStore((s) => s.setToSave);

  return (
    <Tooltip label={lang.campaign.save_tooltip}>
      <Button
        size="md"
        leftSection={<IconDeviceFloppy size={18} />}
        variant="light"
        fw={400}
        radius={"md"}
        pos={"absolute"}
        bottom={16}
        left={navbarClosed ? 96 : 256}
        onClick={() => {
          setToSave("save_only");
          let submitter = document.getElementById("workflow-config-submitter");
          submitter.click();
        }}
      >
        {lang.campaign.save}
      </Button>
    </Tooltip>
  );
};

export default WorkflowSaver;
